import { IsEmail, Length } from 'class-validator';

import { UserUpdateModel } from './userUpdate.model';

export class UserManagementUpdateModel extends UserUpdateModel {
  @Length(2, 64)
  @IsEmail()
  public email: string;
}
